import React from 'react';
import { Box, Container, Heading, Text, Button, Link, VStack, useColorModeValue } from '@chakra-ui/react';
import SectionTitleCard from './SectionTitleCard';

const HappyHour = () => {
  const bgGradient = useColorModeValue(
    'linear(to-b, blue.50, white)',
    'linear(to-b, blue.900, gray.900)'
  );

  return (
    <Box 
      id="happy hour" 
      p={8} 
      bgGradient={bgGradient}
      position="relative"
      overflow="hidden"
    >
      {/* Decorative elements */}
      <Box
        position="absolute"
        top="-50px"
        right="-50px"
        width="200px"
        height="200px"
        borderRadius="full"
        bg="blue.100"
        opacity="0.3"
        transform="rotate(30deg)"
      />
      <Box
        position="absolute"
        bottom="-50px"
        left="-50px"
        width="200px"
        height="200px"
        borderRadius="full"
        bg="blue.100"
        opacity="0.3"
        transform="rotate(-30deg)"
      />

      <Container maxW={'7xl'} mt={12} mb={12} position="relative">
        <VStack spacing={8}>
          <SectionTitleCard gradient="linear(to-r, white.50, white.100)">
            Happy Hour
          </SectionTitleCard>
          
          <Heading 
            fontSize={{ base: '2xl', md: '4xl' }}
            textAlign="center"
            bgGradient="linear(to-r, blue.600, blue.400)"
            bgClip="text"
            fontWeight="extrabold"
          >
            FBC '25 & Lyquor Labs | Santa Barbara Happy Hour
          </Heading>
          
          <Text 
            fontSize="xl" 
            textAlign="center"
            color="gray.600"
            maxW="2xl"
          >
            Join us for an evening of networking and celebration
          </Text>
          
          <Box 
            p={4} 
            borderRadius="xl" 
            bg="white" 
            boxShadow="xl"
            width="full"
            maxW="md"
            textAlign="center"
          >
            <Text fontSize="lg" fontWeight="bold" color="blue.600">
              May 16, 2025
            </Text>
          </Box>

          <Text 
            fontSize="md" 
            textAlign="center"
            color="gray.600"
            maxW="2xl"
          >
            Connect with industry leaders, researchers, and fellow blockchain enthusiasts
            in a relaxed atmosphere before the main conference.
          </Text>

          <Link 
            href="https://www.eventbrite.co.uk/e/fbc-25-lyquor-labs-santa-barbara-happy-hour-may-16-530-pm-tickets-1362384892889?aff=oddtdtcreator" 
            target="_blank"
            _hover={{ textDecoration: 'none' }}
          >
            <Button
              bgGradient="linear(to-r, blue.400, blue.600)"
              rounded={'full'}
              color={'white'}
              _hover={{ 
                bgGradient: 'linear(to-r, blue.600, blue.800)',
                transform: 'translateY(-2px)',
                boxShadow: 'lg'
              }}
              _active={{
                transform: 'translateY(0)'
              }}
              boxShadow="md"
              size="lg"
              px={8}
              transition="all 0.2s"
            >
              Register for Happy Hour
            </Button>
          </Link>
          <Text fontSize="sm" color="gray.500" mt={2}>
            Registration required to attend
          </Text>
        </VStack>
      </Container>
    </Box>
  );
};

export default HappyHour;
